// ---------------------------------------------------------------------------
// MMH Products service configuration
// ---------------------------------------------------------------------------
// Set USE_MOCK to false (or REACT_APP_MMH_PRODUCTS_MOCK=false) once the
// completedproject module is deployed. Nothing else in the module changes —
// the mock and the real services take and return the same shapes.

export const USE_MOCK = process.env.REACT_APP_MMH_PRODUCTS_MOCK !== "false";

// The api project's `completedproject` module. Its controller is named after
// the module, so the module segment is the base path.
export const MMH_PRODUCTS_BASE_PATH = "completedproject";

export const MMH_MASTERS_PATH = "completedproject/masters";
export const MMH_KEYWORDS_PATH = "completedproject/keywords";
export const MMH_PINCODE_PATH = "completedproject/pincode";

// Existing project-management lookup that pre-fills Dimensions & Structure.
export const PROJECT_BY_CODE_PATH = "internal/pm";
